<template>
  <div class="modal-mask">
    <section class="modal progressBar">
      <div class="content centered2">
        <span class=""><img src="@/assets/images/Loading.gif" width="50" height="50"/></span>
        <span class="pSpace ">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{parMessage}}</span>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: ["parMessage"],
  data() {
    return {};
  },
  methods: {}
};
</script>